import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "../css/Confirmation.css";
import { useTranslation } from "react-i18next";

const Confirmation = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { reservation } = location.state || {};
  const bookingReference = reservation?.booking_reference || "N/A";

  const handleGoHome = () => {
    navigate("/");
  };

  useEffect(() => {}, [i18n.language, t]);

  return (
    <div className="confirmation-container">
      <div className="confirmation-card">
        <div className="icon-container">
          <FaCheckCircle className="confirmation-icon" />
        </div>
        <h2 className="confirmation-title">{t("confirmationTitle")}</h2>
        <p className="confirmation-message">{t("confirmationMessage")}</p>
        <p className="confirmation-details">
          {i18n.language === "ID"
            ? "Email konfirmasi telah dikirim ke alamat email yang terdaftar"
            : t("confirmationDetail")}
        </p>
        <p className="confirmation-ref">
          {i18n.language === "ID" ? "Booking Reference" : t("bookingReference")}{" "}
          : <strong>{bookingReference}</strong>
        </p>
        <button className="home-button" onClick={handleGoHome}>
          {i18n.language === "ID" ? "Kembali ke Beranda " : t("goToHome")}
        </button>
      </div>
    </div>
  );
};

export default Confirmation;
